(async function () {
    // const TIERED_RULES = [
    //     { min: 209500, requiredVariants: [45403015807162, 45403015839930, 45403015872698] },
    //     { min: 179500, requiredVariants: [45403015807162, 45403015839930] },
    //     { min: 129500, requiredVariants: [45403015807162] }
    // ];

    const TIERED_RULES = [
        { min: 209500, requiredVariants: [45403015872698, 45403015839930, 45403015807162] },
        { min: 179500, requiredVariants: [45403015872698, 45403015839930] },
         { min: 129500, requiredVariants: [45403015872698] }
    ];
    

    const ALL_BUNDLE_VARIANTS = TIERED_RULES.flatMap(rule => rule.requiredVariants);

    /**
     * Determines the mandatory variants based on the cart total.
     * @param {number} total - The total cart price in cents.
     * @returns {number[]} Array of variant IDs that MUST be in the cart for the highest valid tier.
     */
    function getRequiredVariants(total) {
        for (let rule of TIERED_RULES) {
            if (total >= rule.min) {
                return rule.requiredVariants;
            }
        }
        return [];
    }

    async function getCart() {
        return fetch('/cart.js').then(r => r.json());
    }

    function applyOfferCleanup() {
        document.body.classList.remove('free_offer_wait');
    }

    async function updateCart(updates) {
        const cartDrawer = document.querySelector('cart-drawer');
        const payload = {
            updates: updates,
            sections: cartDrawer?.getSectionsToRender()?.map(s => s.id) || [],
            sections_url: window.location.pathname
        };

        try {
            const response = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(payload),
                credentials: 'same-origin'
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            cartDrawer?.renderContents(data);

            await new Promise(resolve => {
                window.requestAnimationFrame(() => {
                    resolve();
                });
            });

        } catch (error) {
            console.error(error);
            applyOfferCleanup();
        }
    }

    async function addToCart(variantId) {
        try {
            const cartDrawer = document.querySelector('cart-drawer');
            const handleAddToCart = {
                id: variantId,
                quantity: 1
            };
            const bundleCart = {
                items: [handleAddToCart],
                sections: cartDrawer?.getSectionsToRender()?.map(s => s.id) || [],
                sections_url: window.location.pathname
            };

            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(bundleCart),
                credentials: 'same-origin'
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            cartDrawer?.renderContents(data);

            await new Promise(resolve => {
                window.requestAnimationFrame(() => {
                    resolve();
                });
            });

        } catch (error) {
            console.error(error);
            applyOfferCleanup();
        }
    }

    async function applyOffer() {
        document.body.classList.add('free_offer_wait');

        try {
            const cart = await getCart();
            const cartTotal = cart.total_price; 
            const requiredVariants = getRequiredVariants(cartTotal); 
            
            let updates = {};
            let variantsCurrentlyInCart = cart.items.map(item => item.variant_id);
            let updateNeeded = false;
            
            cart.items.forEach(item => {
                if (ALL_BUNDLE_VARIANTS.includes(item.variant_id)) {
                    if (!requiredVariants.includes(item.variant_id)) {
                        updates[item.variant_id] = 0;
                        updateNeeded = true;
                    }
                }
            });

            if (Object.keys(updates).length > 0) {
                await updateCart(updates);
            }
            
            if (requiredVariants.length > 0) {
                for (const requiredVariantId of requiredVariants) {
                    if (!variantsCurrentlyInCart.includes(requiredVariantId)) {
                        await addToCart(requiredVariantId);
                    }
                }
            }

        } catch (error) {
            console.error('Error applying offer/bundle:', error);
            applyOfferCleanup();
            return;
        }
        applyOfferCleanup();
    }

    applyOffer();
    document.addEventListener('cart:offert', function () {
        applyOffer();
    });
})();